import dayjs from "dayjs";

/**
 * Checks for an integer value in range
 */
export function isIntegerInRange(value: any, min: number, max: number) {
  if (
    value === undefined ||
    value === null ||
    value === "" ||
    isNaN(parseFloat(value)) ||
    !isFinite(+value)
  ) {
    return false;
  }

  const numValue = Math.floor(+value);

  if ("" + numValue !== value) {
    return false;
  }

  if (numValue < min || numValue > max) {
    return false;
  }

  return true;
}

/**
 * Checks for a null or empty value
 */
export function isNullOrEmpty(value) {
  if (value === undefined || value === null || value === "") {
    return true;
  }

  return false;
}

/**
 * Checks a valid email address
 */
export function isEmail(email: string, amazonOnly: boolean): boolean {
  if (isNullOrEmpty(email)) {
    return false;
  }

  const amazonRegex = /^[^\s@]+@amazon\.[^\s@]+$/;
  const anyRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (amazonOnly) {
    return amazonRegex.test(email);
  } else {
    return anyRegex.test(email);
  }
}

/**
 * Renders localized date and time
 */
export function formatLocalDateTime(input: string): string {
  return dayjs(input).format("D MMMM YYYY, h:mma");
}

/**
 * Clamps a string at the max length adding ellipsis
 */
export function ellipsisText(input: string, maxLength: number): string {
  if (isNullOrEmpty(input)) {
    return "";
  }

  if (input.length > maxLength) {
    return input.substring(0, maxLength) + "...";
  }

  return input;
}

/**
 * Checks for a number
 */
export function isNumber(value: any): boolean {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
